export default __webpack_public_path__ + "static/media/CodePen.5c3a32f5.png";